import { useState } from "react";

const GOLD = "#F9A826";
const BLUE = "#0f1729";
const TIPOS = ["Culto", "Célula", "Ensaio", "Conferência", "Outro"];

export default function NovoEvento({ onSalvar, onCancelar, membros, tema: T, loading = false }) {
    const [titulo, setTitulo] = useState("");
    const [tipo, setTipo] = useState("Culto");
    const [data, setData] = useState("");
    const [membrosSel, setMembrosSel] = useState([]);

    const toggleMembro = (m) => {
        setMembrosSel(prev =>
            prev.find(x => x.nome === m.nome)
                ? prev.filter(x => x.nome !== m.nome)
                : [...prev, m]
        );
    };

    const salvar = () => {
        if (!titulo || !data) return alert("Preencha título e data!");
        const [ano, mes, dia] = data.split("-");
        const dataFormatada = `${dia}/${mes}/${ano}`;
        // Não gera ID local — o backend retorna o UUID real
        onSalvar({
            titulo,
            tipo,
            data,
            dataFormatada,
            integrantes: membrosSel,
            setlist: [],
        });
    };

    return (
        <div style={{ background: T.bgCard, borderRadius: 16, padding: 16, marginBottom: 16, border: `1px solid ${T.borda}` }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: T.texto, marginBottom: 14 }}>➕ Novo Evento</div>

            {/* Tipo */}
            <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: T.textoSecundario, marginBottom: 6 }}>Tipo</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {TIPOS.map(t => (
                        <button key={t} onClick={() => setTipo(t)} style={{
                            padding: "5px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600,
                            border: `1px solid ${tipo === t ? GOLD : T.borda}`,
                            background: tipo === t ? GOLD : T.bgCardSecundario,
                            color: tipo === t ? BLUE : T.texto, cursor: "pointer"
                        }}>{t}</button>
                    ))}
                </div>
            </div>

            {/* Título */}
            <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: T.textoSecundario, marginBottom: 4 }}>Título</div>
                <input
                    value={titulo}
                    onChange={e => setTitulo(e.target.value)}
                    placeholder={`Ex: ${tipo} da Manhã`}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: `1px solid ${T.borda}`, background: T.input, color: T.texto, fontSize: 14, boxSizing: "border-box" }}
                />
            </div>

            {/* Data */}
            <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, color: T.textoSecundario, marginBottom: 4 }}>Data</div>
                <input
                    type="date"
                    value={data}
                    onChange={e => setData(e.target.value)}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: `1px solid ${T.borda}`, background: T.input, color: T.texto, fontSize: 14, boxSizing: "border-box" }}
                />
            </div>

            {/* Membros */}
            {membros?.length > 0 && (
                <div style={{ marginBottom: 14 }}>
                    <div style={{ fontSize: 12, color: T.textoSecundario, marginBottom: 8 }}>Membros ({membrosSel.length} selecionados)</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                        {membros.map((m, i) => {
                            const sel = membrosSel.find(x => x.nome === m.nome);
                            return (
                                <button key={i} onClick={() => toggleMembro(m)} style={{
                                    display: "flex", alignItems: "center", gap: 6,
                                    padding: "6px 10px", borderRadius: 20, fontSize: 12,
                                    border: `2px solid ${sel ? GOLD : T.borda}`,
                                    background: sel ? `${GOLD}22` : T.bgCardSecundario,
                                    color: T.texto, cursor: "pointer", fontWeight: sel ? 700 : 400
                                }}>
                                    {m.foto
                                        ? <img src={m.foto} alt={m.nome} style={{ width: 22, height: 22, borderRadius: "50%", objectFit: "cover" }} />
                                        : <span style={{ fontSize: 14 }}>👤</span>}
                                    {m.nome}
                                    {m.funcao && <span style={{ color: GOLD, fontSize: 10 }}>· {m.funcao}</span>}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}

            {membros?.length === 0 && (
                <div style={{ fontSize: 12, color: T.textoSecundario, marginBottom: 14, background: T.bgCardSecundario, borderRadius: 10, padding: "8px 12px" }}>
                    💡 Nenhum membro cadastrado ainda.
                </div>
            )}

            {/* Botões */}
            <div style={{ display: "flex", gap: 8 }}>
                <button
                    onClick={onCancelar}
                    disabled={loading}
                    style={{ flex: 1, padding: 12, borderRadius: 10, background: T.bgCardSecundario, border: `1px solid ${T.borda}`, color: T.texto, fontWeight: 600, cursor: loading ? "default" : "pointer", opacity: loading ? 0.5 : 1 }}
                >
                    Cancelar
                </button>
                <button
                    onClick={salvar}
                    disabled={loading}
                    style={{ flex: 2, padding: 12, borderRadius: 10, background: loading ? T.borda : GOLD, border: "none", color: BLUE, fontWeight: 700, cursor: loading ? "default" : "pointer" }}
                >
                    {loading ? "Criando evento..." : "Salvar evento ✓"}
                </button>
            </div>
        </div>
    );
}